import { isAction, Middleware } from '@reduxjs/toolkit';
import {
  fetchToken,
  initializeAuth,
  refreshAuthToken,
  userLoggedIn,
  userLoggedOut,
} from '../reducers/authInfoReducer';
import { invalidateModules } from '../reducers/modules-reducer';
import { fetchAvailableThemes, fetchCurrentTheme } from '../reducers/themeEditorReducer';

const AUTH_INIT_ACTIONS = new Set([
  userLoggedIn.type,
  userLoggedOut.type,
  fetchToken.fulfilled.type,
  refreshAuthToken.fulfilled.type,
]);

export const authSyncMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const result = next(action);

    if (isAction(action)) {
      if (refreshAuthToken.fulfilled.match(action)) {
        dispatch(invalidateModules());
      }

      if (userLoggedIn.match(action)) {
        dispatch(fetchAvailableThemes());
        dispatch(fetchCurrentTheme());
      }

      if (AUTH_INIT_ACTIONS.has(action.type)) {
        dispatch(initializeAuth());
      }
    }

    return result;
  };
